import { OptionWithValuesMulti } from './option-with-values-mulit';

export class OptionCheckbox extends OptionWithValuesMulti {
    readonly type = 'checkbox';
}
